export default __webpack_public_path__ + "static/media/analytics.6b93e086.svg";